<app-custom-modal-header [title]="title" [subtitle]="subtitle" (onCloseClick)="onCloseClick.emit($event)"
  (onReturnClick)="onReturnClick.emit($event)" [showReturn]="showReturn" (onDeleteClick)="onDeleteClick.emit($event)"
  [showDelete]="showDelete" />
<app-custom-modal-body>
  <ng-content></ng-content>
</app-custom-modal-body>
<app-custom-modal-footer [hideCancel]="hideCancel" [hideSave]="hideSave" [cancelDisabled]="cancelDisabled"
  [buttonImage]="buttonImage" [cancelLabel]="cancelLabel" (onCancelClick)="close()" [saveDisabled]="saveDisabled"
  [saveLabel]="saveLabel" (onSaveClick)="onSaveClick.emit($event)" [customButtonDisabled]="saveDisabled"
  [showCustomButton]="showCustomButton" [customButtonLabel]="customButtonLabel"
  (onCustomButtonClick)="onCustomButtonClick.emit($event)"></app-custom-modal-footer>